import AsyncStorage from "@react-native-async-storage/async-storage";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export enum ViewableContent {
  APP_WELCOME = 1
}

interface ViewedContentState {
  viewedContent: {
    [username: string]: number;
  };
  viewContent: (
    content: ViewableContent,
    username: string | null | undefined
  ) => void;
  hasViewedContent: (
    content: ViewableContent,
    username: string | null | undefined
  ) => boolean;
}

const initialValues = {
  viewedContent: {}
};

const normalizeUsername = (username: string | null | undefined) =>
  username?.toLocaleLowerCase().trim() || "";

export const useViewedContentStore = create<ViewedContentState>()(
  persist(
    (set, get) => ({
      ...initialValues,
      viewContent: (content, username) => {
        const normalizedUsername = normalizeUsername(username);

        if (!normalizedUsername) {
          return;
        }

        const currentViewedContent = get().viewedContent;
        const flag = get().viewedContent[normalizedUsername] || 0;
        set({
          viewedContent: {
            ...currentViewedContent,
            // Sets the bit in the flag using the | (OR) operator
            [normalizedUsername]: flag | content
          }
        });
      },
      hasViewedContent: (content, username) => {
        const normalizedUsername = normalizeUsername(username);

        if (!normalizedUsername) {
          return false;
        }

        const currentViewedContent = get().viewedContent;
        const flag =
          currentViewedContent[normalizedUsername] ||
          currentViewedContent[username?.trim() || ""] ||
          0;
        // Compares if bit is present in flag using the & (AND) operator
        return (flag & content) === content;
      }
    }),
    {
      name: "ViewedContentStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);
